import { useMutation } from "@apollo/client";
import { useQueryClient } from "@tanstack/react-query";
import useGetDashboard, {
	getDashboardQueryKey,
} from "api/queries/useGetDashboard";
import { graphql } from "gql/apollo";
import { useActiveAccount } from "utils/useActiveAccount";
import useSnackbar from "utils/useSnackbar";

export const UpdateDashboardTabOrderMutation = graphql(/* GraphQL */ `
	mutation UpdateDashboardTabOrder($params: UpdateDashboardTabOrderParams!) {
		updateDashboardTabOrder(params: $params) {
			error {
				code
				message
			}
		}
	}
`);

export const useOrderedDashboardTabs = () => {
	const { data: dashboard } = useGetDashboard();
	const currentTabs = dashboard?.tabs;

	const [updateDashboardTabOrder] = useMutation(
		UpdateDashboardTabOrderMutation
	);

	const queryClient = useQueryClient();
	const { _id: accountId, userId } = useActiveAccount();
	const dashboardQueryKey = getDashboardQueryKey(userId, accountId);

	const { handleError } = useSnackbar();

	return {
		updateTabOrder: (sourceIndex: number, destinationIndex: number) => {
			// optimistically update the tabs in cache
			if (currentTabs) {
				// remove tab from current location
				const tabAtSource = currentTabs.splice(sourceIndex, 1)[0];

				// insert tab at new location
				currentTabs.splice(destinationIndex, 0, tabAtSource);

				queryClient.setQueryData(dashboardQueryKey, { tabs: currentTabs });
			}

			updateDashboardTabOrder({
				variables: {
					params: {
						originIndex: sourceIndex,
						destinationIndex,
					},
				},
			})
				.then((result) => {
					if (result.data?.updateDashboardTabOrder.error) {
						handleError(result.data.updateDashboardTabOrder.error);
					}
					queryClient.invalidateQueries(dashboardQueryKey);
				})
				.catch((error) => handleError(error));
		},
		dashboardTabs: currentTabs,
	};
};
